/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';

import { Action, ActionType } from '../actionTypes/contractActionTypes';
import { IContract as Contract, IContractConfirmers } from '../../models/contract';
import { IPermission } from '../../models/permission';

export interface IContractsState {
    contracts: Contract[],
    contractConfirmers: IContractConfirmers,
    permissions: IPermission[],
    currentContractId: number,
    currentContractCurrency: string,
    loading: boolean;
    error: string | null,
}
const initialState = {
    contracts: [],
    contractConfirmers: {
        project_manager: '',
        financialInfo_confirmor: '',
        hse_confirmor: '',
        progressState_confirmor: '',
        timeProgressState_confirmor: '',
        invoice_confirmor: '',
        financialInvoice_confirmor: '',
        workVolume_confirmor: '',
        pmsProgress_confirmor: '',
        budget_confirmor: '',
        machinary_confirmor: '',
        projectPersonel_confirmor: '',
        problem_confirmor: '',
        criticalAction_confirmor: '',
        projectDox_confirmor: '',
        periodicDox_confirmor: '',
        zoneImage_confirmor: ''
    },
    permissions: [],
    currentContractId: 0,
    currentContractCurrency: '',
    loading: false,
    error: null,   
};
export const ContractReducer: Reducer<IContractsState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_CONTRACT:
        case ActionType.FETCH_CONTRACTS:
        case ActionType.FETCH_CONTRACTCHANGES:
        case ActionType.ADD_CONTRACT:
        case ActionType.EDIT_CONTRACT:
        case ActionType.DELETE_CONTRACT:
            return { ...state, loading: true };

        case ActionType.FETCH_CONTRACT_FAIL:
        case ActionType.FETCH_CONTRACTS_FAIL:
        case ActionType.FETCH_CONTRACTCHANGES_FAIL:
        case ActionType.ADD_CONTRACT_FAIL:
        case ActionType.EDIT_CONTRACT_FAIL:
        case ActionType.DELETE_CONTRACT_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };

        case ActionType.FETCH_CONTRACT_SUCCESS:
        case ActionType.ADD_CONTRACT_SUCCESS:
            return {
                ...state,
                contracts: [ ...state.contracts, action.payload ],
                loading: false
            };
        case ActionType.FETCH_CONTRACTS_SUCCESS:
            return {
                ...state,
                contracts: action.payload.data,
                loading: false
            };

        case ActionType.FETCH_CONTRACTCHANGES_SUCCESS:
            const contractid = action.offline_payload.contractid;
            const currency = action.offline_payload.currency;
            const userContractPermissions = action.offline_payload.userContractPermissions;
            return {
                ...state,
                contractConfirmers: action.payload.data,
                currentContractId: contractid,
                currentContractCurrency: currency,
                permissions: userContractPermissions.length === 1 && userContractPermissions[0].projectid === null
                             ? 
                                userContractPermissions[0].permissions
                             :
                                userContractPermissions.filter(x => x.projectid === contractid) &&
                                userContractPermissions.filter(x => x.projectid === contractid).length > 0 
                                ? 
                                    userContractPermissions.filter(x => x.projectid === contractid)[0].permissions
                                : 
                                    [],
                loading: false
            };   

        case ActionType.EDIT_CONTRACT_SUCCESS:
            const contract: Contract = action.payload
            const index = state.contracts.findIndex(itm => itm.contractid === contract.contractid)
            const contractsPart1 = state.contracts.slice(0, index)
            const contractsPart2 = state.contracts.slice(index + 1)
            return {
                ...state,
                contracts: [ ...contractsPart1, contract, ...contractsPart2 ],
                loading: false
            };
        case ActionType.DELETE_CONTRACT_SUCCESS:
            return {
                ...state,
                contracts3: state.contracts.filter(contract => contract.contractid !== action.payload),
            };
        default:
            return state;
    }
};
